export default __webpack_public_path__ + "static/media/anh_nen_conf.9e6be0d2.jpg";